import { render, staticRenderFns } from "./TotalSprPage.vue?vue&type=template&id=22b5fb64"
import script from "./totalSpr.js?vue&type=script&lang=js&external"
export * from "./totalSpr.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports